import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Variant = makeShortcode("Variant");
const InlineNestedAlert = makeShortcode("InlineNestedAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Variant platform="outdated-version" componentClass="InlineNestedAlert" repeat="1" mdxType="Variant" />
    <InlineNestedAlert variant="error" header="false" iconPosition="left" mdxType="InlineNestedAlert">
      <p>{`This document lists information about the `}<strong parentName="p">{`previous versions`}</strong>{` of the Adobe Experience Platform Mobile SDKs. Check out `}<a parentName="p" {...{
          "href": "https://developer.adobe.com/client-sdks/documentation/current-sdk-versions/"
        }}>{`this page for latest versions and solution support`}</a>{` of the Mobile SDKs.`}</p>
    </InlineNestedAlert>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      